import { FC } from 'react';
import CountrySpecific from '../../../common/country-specific/country-specific';
import Amazon from '../../../images/payment-logos/border-logos/amazon-logo.svg';
import MasterCard from '../../../images/payment-logos/border-logos/mastercard-logo.svg';
import Paypal from '../../../images/payment-logos/border-logos/payPal-logo.svg';
import Rechnung from '../../../images/payment-logos/border-logos/rechnung-logo.svg';
import Sepa from '../../../images/payment-logos/border-logos/sepa-logo.svg';
import Visa from '../../../images/payment-logos/border-logos/visa-logo.svg';
import ApplePay from '../../../images/payment-logos/svg/apple.svg';
import GooglePay from '../../../images/payment-logos/svg/google_pay.svg';
import iDEALPay from '../../../images/payment-logos/svg/ideal.svg';
import BancontactPay from '../../../images/payment-logos/svg/bancontact.svg';
import KlarnaPay from '../../../images/payment-logos/svg/klarna_white.svg';
import cn from '../../../utils/classnames';
import detectBrowser from '../../../utils/detect-browser';
import './payment-logos.scss';

type PaymentIconsProps = {
    className?: string;
};

const PaymentLogos: FC<PaymentIconsProps> = ({ className }) => (
    <div className='d-flex justify-content-center'>
        <div className={cn('payment-logos d-flex justify-content-center flex-wrap', className)}>
            <img src={Paypal} alt='Paypal Logo' />
            <img src={Visa} alt='Visa Logo' />
            <img src={MasterCard} alt='MasterCard Logo' />
            <img src={Amazon} alt='Amazon Logo' />
            <CountrySpecific allowed='de'>
                <img src={Sepa} alt='Sepa Logo' />
            </CountrySpecific>
            <CountrySpecific allowed='de'>
                <img src={Rechnung} alt='Rechnung Logo' />
            </CountrySpecific>
            {detectBrowser() === 'Safari' && <img src={ApplePay} alt='Apple Pay Logo' height='30' />}
            <img src={GooglePay} alt='Google Pay Logo' height='30' />
            <CountrySpecific allowed={['de', 'nl']}>
                <img src={KlarnaPay} alt='Klarna Pay Now Logo' height='30' />
            </CountrySpecific>
            <CountrySpecific allowed='nl'>
                <>
                    <img src={iDEALPay} alt='iDEAL Logo' height='30' />
                    <img src={BancontactPay} alt='Bancontact Logo' height='30' />
                </>
            </CountrySpecific>
        </div>
    </div>
);

export default PaymentLogos;
